angular.module('Itao.IndicatorMap').factory('GridItemWidgetCompiler', function($compile){
  'use strict';

  /**
   * Map object which connects widgetKey with its compileFunction
   * @type {Object}
   */
  var keyToDirectiveMap = {
    'barChart': compileBarChart,
    'setBarChart': compileSetBarChart,
    'barChartDoubleAxis': compileBarChartDoubleAxis,
    'barChartYears': compileBarChartYears,
    'barChartYearsWithoutArea': compileBarChartYearsWithoutArea,
    'horizontalBarChart': compileHorizontalBarChart,
    'horizontalStackedBarChart': compileHorizontalStackedBarChart,
    'horizontalStackedSetBarChart': compileHorizontalStackedSetBarChart,
    'stackedSetBarChart': compileStackedSetBarChart,
    'setRefPointBarChart': compileSetRefPointBarChart,
    'stackedSetAbsoluteBarChart': compileStackedSetAbsoluteBarChart,
    'stackedGroupedSetBarChart': compileStackedGroupedSetBarChart,
    'lineChart': compileLineChart,
    'scatterPlot': compileScatterPlot,
    'featureTable': compileFeatureTable,
    'transposedFeatureTable': compileTransposedFeatureTable,
    'setTable': compileSetTable,
    'map': compileMap,
    'districtsPieChart': compileDistrictsPieChart,
    'textfield': compileTextfield
  };

  /**
   * Returns the template function for a textfield and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileTextfield(config) {
    return $compile('<textfield config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></textfield>');
  }

  /**
   * Returns the template function for a featureTable and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileFeatureTable(config) {
    return $compile('<feature-table layer="diagramData.selectedDataLayer" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" ></feature-table>');
  }

  /**
   * Returns the template function for a transposedFeatureTable and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileTransposedFeatureTable(config) {
    return $compile('<transposed-feature-table layer="diagramData.selectedDataLayer" disabled-district-keys="diagramData.disabledDistrictKeys" selected-districts="diagramData.selectedDistricts" color-sets="diagramData.colorSets" indicators="diagramData.indicators" config="config.widget" ></transposed-feature-table>');
  }

  /**
   * Returns the template function for a setTable
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileSetTable(config) {
    return $compile('<set-table layer="diagramData.selectedDataLayer" disabled-district-keys="diagramData.disabledDistrictKeys" selected-indicator-set="diagramData.selectedIndicatorSet" disabled-list-index="diagramData.disabledListIndex" color-sets="diagramData.colorSets" config="config.widget"></set-table>');
  }

  /**
   * Returns the template function for a map and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileMap(config) {
    // console.log("config inside compiler", config);
    return $compile('<indicator-map '
      + 'districts="diagramData.districts" '
      + 'selected-districts="diagramData.selectedDistricts" '
      + 'selected-indicators="diagramData.indicators" '
      + 'layers="diagramData.layers" '
      + 'poi-layers="diagramData.poiLayers" '
      + 'poi-layer-types="diagramData.poiDataLayerTypes" '
      + 'poi-data="diagramData.poiData" '
      + 'color-sets="diagramData.colorSets" '
      + 'indicator-sets="diagramData.indicatorSets" '
      + 'config="config.widget" '
      + 'selected-data-layer="diagramData.selectedDataLayer" '
      + 'selected-poi-layer="diagramData.selectedPoiLayer" '
      + 'select-district="selectDistrict(district)" '
      + 'deselect-district="deselectDistrict(district)" '
      + 'dimension-x="{{config.width}}" dimension-y="{{config.height}}" '
      + '></indicator-map>');
  }

  /**
   * Returns the template function for a barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileBarChart(config) {
    return $compile('<bar-chart layer="diagramData.selectedDataLayer" selected-chart-colorset="diagramData.selectedChartColorset" colorsets="diagramData.colorSets" disabled-district-keys="diagramData.disabledDistrictKeys" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></bar-chart>');
  }

  /**
   * Returns the template function for a stacked barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileSetBarChart(config) {
    return $compile('<set-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></set-bar-chart>');
  }

  /**
   * Returns the template function for a barChartYears and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileBarChartYears(config) {
    return $compile('<bar-chart-years layers="diagramData.layers" selected-chart-colorset="diagramData.selectedChartColorset" decimals-override="diagramData.decimalsOverride" max-axis-value-override="diagramData.maxAxisValueOverride" disabled-district-keys="diagramData.disabledDistrictKeys" disabled-data-layers="diagramData.disabledDataLayers" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></bar-chart-years>');
  }

  /**
   * Returns the template function for a barChartYearsWithoutArea and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileBarChartYearsWithoutArea(config) {
    return $compile('<bar-chart-years layers="diagramData.layers" selected-chart-colorset="diagramData.selectedChartColorset" disabled-district-keys="diagramData.disabledDistrictKeys" disabled-data-layers="diagramData.disabledDataLayers" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}" without-area="1"></bar-chart-years>');
  }

  /**
   * Returns the template function for a barChartDoubleAxis and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileBarChartDoubleAxis(config) {
    return $compile('<bar-chart-double-axis layer="diagramData.selectedDataLayer" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></bar-chart-double-axis>');
  }

  /**
   * Returns the template function for a horizontalBarChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileHorizontalBarChart(config) {
    return $compile('<horizontal-bar-chart layer="diagramData.selectedDataLayer" selected-chart-colorset="diagramData.selectedChartColorset" colorsets="diagramData.colorSets" disabled-district-keys="diagramData.disabledDistrictKeys" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></horizontal-bar-chart>');
  }

  /**
   * Returns the template function for a stacked barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileHorizontalStackedBarChart(config) {
    return $compile('<horizontal-stacked-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" indicators="diagramData.indicators" indicator-sets="diagramData.indicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></horizontal-stacked-bar-chart>');
  }

  /**
   * Returns the template function for a stacked set barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileHorizontalStackedSetBarChart(config) {
    return $compile('<horizontal-stacked-set-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></horizontal-stacked-set-bar-chart>');
  }

  /**
   * Returns the template function for a stacked barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileStackedSetBarChart(config) {
    return $compile('<stacked-set-bar-chart use-absolute-values="0" layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></stacked-set-bar-chart>');
  }

  /**
   * Returns the template function for a stacked barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileStackedSetAbsoluteBarChart(config) {
    return $compile('<stacked-set-bar-chart use-absolute-values="1" layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></stacked-set-bar-chart>');
  }

   /**
   * Returns the template function for a barChart with reference point and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileSetRefPointBarChart(config) {
    return $compile('<set-ref-point-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></set-ref-point-bar-chart>');
  }

  /**
   * Returns the template function for a stacked barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileStackedGroupedSetBarChart(config) {
    return $compile('<stacked-grouped-set-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></stacked-grouped-set-bar-chart>');
  }

  /**
   * Returns the template function for a lineChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileLineChart(config) {
    return $compile('<line-chart layer="diagramData.selectedDataLayer" layers="diagramData.layers" yearly-mode="diagramData.enableYearlyMode" disabled-data-layers="diagramData.disabledDataLayers" no-data-districts="diagramData.noDataDistricts" selected-district-key="diagramData.selectedDistrictKey" selected-districts="diagramData.selectedDistricts" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" mouse-over-feature="diagramData.mouseOverFeature" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></line-chart>');
    //return $compile('<horizontal-stacked-set-bar-chart layer="diagramData.selectedDataLayer" disabled-list-index="diagramData.disabledListIndex" disabled-district-keys="diagramData.disabledDistrictKeys" colorsets="diagramData.colorSets" indicators="diagramData.indicators" indicator-sets="diagramData.selectAbleIndicatorSets" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></horizontal-stacked-set-bar-chart>');
  }

  /**
   * Returns the template function for a scatterPlot and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileScatterPlot(config) {
    return $compile('<scatter-plot layer="diagramData.selectedDataLayer" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></scatter-plot>');
  }

  /**
   * Returns the template function for a barChart and wires up the configuration attributes
   * @param {Object} config configuration object of grid item
   * @returns {Function} Angular template function from $compile, needs to be executed with a scope
   */
  function compileDistrictsPieChart(config) {
    return $compile('<districts-pie-chart layer="diagramData.selectedDataLayer" selected-districts="diagramData.selectedDistricts" indicators="diagramData.indicators" config="config.widget" dimension-x="{{config.width}}" dimension-y="{{config.height}}"></districts-pie-chart>');
  }

  /**
   * Returns the template function for a widgets identified by a key
   * @param {String} key key of the directive
   * @param {Object} config configuration object of grid item
   * @returns {Function} a angular template function returned by $compile
   */
  function generateTemplateFunctionByType(key, config) {
    var templateFunction = keyToDirectiveMap[key];
    if(angular.isFunction(templateFunction)) {
      return templateFunction(config);
    } else {
      throw new Error('No compile function specified for type ' + key + ' in GridItemWidgetCompiler');
    }
  }


  return {
    generateTemplateFunctionByType: generateTemplateFunctionByType
  };

});
